export default "__VITE_ASSET__BKOuxp0c__"